import React, {Component} from 'react';
import {Grid, Col, Row, Button,ControlLabel, FormControl} from 'react-bootstrap';


import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';


export default class AdminRecordSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
            filterOptions: {
                perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,

            }
        };

    };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('filterOptions', filterOptions);
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }


        if (filterOptions.Expired) {
            queryParams.Expired = filterOptions.Expired;
        }
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }


    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
         var self = this;
        return (
            <div className="product-search-block">
                <Row  >

                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>

                    <Col xs={6} sm={4} md={3} lg={2} className=" top10">
                         <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder="Status"
                            options={[
                                {value: 'true', label: 'Expired'},
                                // {value: 'false', label: 'Active'}
                            ]}
                            onChange={(option) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Expired:option ?  option.value : false,
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                             value={self.state.filterOptions.Expired}
                        />
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>

                </Row>

            </div>
        );

    }
}



